import React from 'react';
import { motion } from 'framer-motion';
import { IMAGES } from '../../data/images';

export default function SmileyCertification() {
  return (
    <motion.div 
      className="flex items-center justify-center gap-3"
      whileHover={{ scale: 1.02 }}
    >
      <motion.img
        src={IMAGES.icons.smiley}
        alt="Elite Smiley"
        className="w-8 h-8"
        initial={{ rotate: 0 }}
        whileHover={{ rotate: 10 }}
        transition={{ duration: 0.2 }}
      />
      <a
        href="https://www.findsmiley.dk/Sider/Search.aspx?k=bennys%20p%C3%B8lsevogn%2C%20brog%C3%A5rdsvej%2014%2C%202820%20Gentofte"
        target="_blank"
        rel="noopener noreferrer"
        className="text-sm hover:text-yellow-200 transition-colors"
      >
        Se vores fødevarekontrol rapport på Findsmiley.dk
      </a>
    </motion.div>
  );
}